import angular from 'angular';
import { changePageTitle } from 'auth/actions/session.actions';

export default angular.module('retailerDashboardsRouting', []).config([
  '$stateProvider',
  ($stateProvider) => {
    $stateProvider
      .state('retailerWidgets-view', {
        parent: 'arw',
        url: '/retailer-dashboards',
        template: `<retailer-dashboards-search-page></retailer-dashboards-search-page>`,
        redirectTo: 'permissions-denied',
        params: {
          pageTitle: [
            '$ngRedux',
            'gettextCatalog',
            ($ngRedux, gettextCatalog) => {
              $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Retailer Dashboards')));
            },
          ],
        },
      })

      .state('retailerWidgets-view-dashboard', {
        parent: 'arw',
        url: '/retailer-dashboard/:retailerNo',
        template: '<retailer-dashboard-page></retailer-dashboard-page>',
        params: {
          pageTitle: [
            '$ngRedux',
            'gettextCatalog',
            ($ngRedux, gettextCatalog) => {
              $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Retailer Dashboard')));
            },
          ],
        },
      });
  },
]);



// WEBPACK FOOTER //
// ./src/modules/retailer-dashboards/retailer-dashboards-routing-module.js